<template>
  <b-card header="Top 10 Hospitals by Transplants" class="mb-3">
    <apexchart
      v-if="series.length > 0"
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    />
    <div v-else class="text-center text-muted py-5">No data available</div>
  </b-card>
</template>

<script>
export default {
  props: {
    data: { type: Array, default: () => [] },
  },
  computed: {
    chartOptions() {
      return {
        chart: { id: "hospital-bar", toolbar: { show: false } },
        xaxis: {
          categories: this.data.map((d) => d.hospital_name),
        },
        colors: ["#28a745"],
        plotOptions: {
          bar: { horizontal: true, borderRadius: 4, barHeight: "60%" },
        },
        dataLabels: { enabled: false },
      };
    },
    series() {
      if (!this.data.length) return [];
      return [
        {
          name: "Transplants",
          data: this.data.map((d) => Number(d.count) || 0),
        },
      ];
    },
  },
};
</script>
